import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { UserService } from 'app/Shared/Services/user.service';
import { MessageService } from 'primeng/api';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import {MatButton} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'app-pwd-change',
    templateUrl: './pwd-change.component.html',
    styleUrls: ['./pwd-change.component.scss'],
    imports: [MatFormField, MatIconModule, ConfirmDialogModule, MatLabel, FormsModule, ReactiveFormsModule, MatButton, MatInputModule, ToastModule]
})
export class PwdChangeComponent implements OnInit {
  form: FormGroup; 
  loading:boolean =false;
  generating:boolean =false;
  isValidDetails:boolean=false;
  showPassword = false;
  showNewPassword = false;
  showConfirmPassword = false;
  msgs:any;
  constructor(public fb: FormBuilder,
    private messageService: MessageService,
    private sharedHttpClientService: SharedHttpClientService,
    private urlsService: UrlsService,
    public constantService: ConstantService,
    private userService: UserService){
    this.form = fb.group({
      'userName': ['',Validators.required],
      'oldPwd': ['',Validators.required],
      'newPwd': ['',Validators.required],
      'confirmPwd': ['',Validators.required]
    })
    }
  ngOnInit(): void {
    this.form = this.fb.group({
      'userName': ['',Validators.required],
      'oldPwd': ['',Validators.required],
      'newPwd': ['',Validators.required],
      'confirmPwd': ['',Validators.required]
    })
  }

  userName(){
    return this.form.get('userName')?.value;
  }

  oldPwd(){
    return this.form.get('oldPwd')?.value;
  }

  newPwd(){
    return this.form.get('newPwd')?.value;
  }

   confirmPwd(){
    return this.form.get('confirmPwd')?.value;
  }

  generateAutoPass() {
    let letters = "PQRSTUVWXYZabcdefg~!@-#$";
    let digits = "01234";
    let string = digits + letters;
    if (this.userName()) {
      string = this.userName() + string.toString().replace(".", "")
    }
    let password = [];
    password.push(digits[Math.floor(Math.random() * digits.length)]);
    password.push(letters[Math.floor(Math.random() * letters.length)])

    while (password.length < 8) {
      password.push(string[Math.floor(Math.random() * string.length)])
    }
    
    password[Math.floor(Math.random() * password.length)] = '@';
    
    let Newpassword = password.join('');
    this.form.get('newPwd')?.setValue(Newpassword);
    this.form.get('confirmPwd')?.setValue(Newpassword);

    this.userService.logUserActivity('User generated random password', null, {
      'Text1': this.userService.getUserFirstName() + ' triggered random password generation',
      'Text2': ''
    });
  }


  resetUserPass(){
    if(this.userName().length>0 &&
       this.oldPwd().length>0 &&
       this.newPwd() == this.confirmPwd()){
    this.loading = true;
    let payload = {
       "userName": this.userName(),
       "oldPassword":this.oldPwd(),
       "newPassword":this.newPwd(),
       "updatedBy":this.userService.getUserFirstName()
     }
      this.sharedHttpClientService.postPlainText(
        this.urlsService.setAPIURl(
          APIURL.changePass
        ), payload
      ).subscribe({
          next: (res: any) => {
            let data = res;
            this.loading = false;
            this.userService.logUserActivity('Change user password', null, {
              'Text1': ' Change user password for ' + this.userName() + ' triggered by ' + this.userService.getUserFirstName(),
              'Text2': ''
            });
            if (data === 'New Password is Updated') {
              this.messageService.add({ severity: 'success', summary: 'User Details', detail: data });
              this.userService.logUserActivity('Change user password', null, {
                'Text1': ' Changed user password successfully for ' + this.userName() + ' triggered by ' + this.userService.getUserFirstName(),
                'Text2': ''
              });
              this.form.reset();
            } else {
              this.messageService.add({ severity: 'success', summary: 'User Details', detail: data });
            }
          },
          error: (err: HttpErrorResponse) => {
            this.loading = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed : Invalid Request' });
            this.userService.logUserActivity('Chaange user password', null, {
              'Text1': 'Failed : Change user password for ' + this.userName() + ' triggered by ' + this.userService.getUserFirstName(),
              'Text2': ''
            });
            this.form.reset();
          }
        })
    }
    else{
     this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please enter correct Details' });
    }
  }

   isValid(){
    
    this.isValidDetails =  this.userName().length>0 &&
    this.oldPwd().length>0 &&
    this.newPwd() == this.confirmPwd();

   }
}
